import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__title mb-0" }
const _hoisted_2 = { class: "fs-18 text-gray" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-custom__content form-custom"
}
const _hoisted_4 = { style: {"height":"calc(100vh - 330px)"} }
const _hoisted_5 = { class: "centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", {
      "data-plant": _ctx.$attrs.plantId,
      class: "dialog-custom__header"
    }, [
      _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("AppResource.Associatethegateway")), 1),
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ChoosegatewayTitle")), 1)
    ], 8, ["data-plant"]),
    (_ctx.plant.mxServer)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_ElScrollbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_SelectButton, {
                  modelValue: _ctx.plant.mxServer.model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.plant.mxServer.model = $event)),
                  options: _ctx.plantServerImages,
                  optionLabel: "value",
                  optionValue: "value",
                  class: "p-selectbutton--blocks p-selectbutton--img-only"
                }, {
                  option: _withCtx((slotProps) => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("img", {
                        src: slotProps.option.imageURLs[0],
                        alt: "img"
                      }, null, 8, ["src"]),
                      _createVNode("div", {
                        class: ["p-3", {'text-dark': _ctx.plant.mxServer.model !== slotProps.option.value }]
                      }, _toDisplayString(_ctx.$t(`AppResource.${_ctx.ServerModel[slotProps.option.value]}`)), 3)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}